import classnames from 'classnames';
import React, { useCallback, useMemo } from 'react';
import StatusAddon from '../../../dataViews/NextTree/addons/StatusAddon';
import useHelpNote from '../../../utils/Translations/useHelpNote';
import useT from '../../../utils/Translations/useT';
import useLayoutDirection from '../../../utils/Translations/useLayoutDirection';
import styles from './SelectBox.scss';
const SelectedBoxButton = ({ props, controlRef, isValueOk, selectedItem, title, addGroupName, groupIndex, setIsOpen, setSearch, isOpen, }) => {
    const { direction, isLayoutRTL, startSide } = useLayoutDirection();
    const { buttonClassNames, isFilterBar = false, loading = false, disabled = false, onOptionLabel, value: selectedValue = '', onOptionTitle = null, placeholder = '', caretClassNames = '', onRenderSelected, withTitle = true, hasInlineLabel = false, itemTitlePropName = 'name', isItemCentered = false, required = false, labelRequired = true, dataCy, tooltipTitle: explicitTooltipTitle = '', } = props;
    const t = useT();
    const getHelpNoteTooltipTitle = useHelpNote();
    const handleToggleMenu = useCallback(() => {
        setIsOpen(!isOpen);
        setSearch('');
    }, [setIsOpen, setSearch, isOpen]);
    const buttonStyle = useMemo(() => classnames('btn dropdown-toggle btn-default', buttonClassNames, styles.buttonPadding, {
        [styles.filterBarButtonStyle]: isFilterBar,
    }), [isFilterBar, buttonClassNames]);
    const selectTitleText = useMemo(() => {
        const selectTitleText = !loading &&
            isValueOk(selectedItem) &&
            onOptionTitle &&
            onOptionTitle(addGroupName(selectedItem, groupIndex));
        return (isValueOk(selectTitleText) ? selectTitleText : placeholder) || '';
    }, [
        addGroupName,
        groupIndex,
        isValueOk,
        loading,
        onOptionTitle,
        placeholder,
        selectedItem,
    ]);
    const getItemTitle = useCallback((item, groupIndex) => onOptionTitle
        ? onOptionTitle(addGroupName(item, groupIndex))
        : item[itemTitlePropName], [addGroupName, itemTitlePropName, onOptionTitle]);
    const selectTitle = useMemo(() => {
        const selectTitle = !loading &&
            isValueOk(selectedItem) &&
            getItemTitle(selectedItem, groupIndex);
        return isValueOk(selectTitle) ? selectTitle : placeholder;
    }, [getItemTitle, groupIndex, isValueOk, loading, placeholder, selectedItem]);
    const buttonHoverTitle = useMemo(() => {
        const titleForTooltip = onOptionLabel
            ? onOptionLabel(selectedValue)
            : selectTitleText || title || '';
        return (explicitTooltipTitle || getHelpNoteTooltipTitle(titleForTooltip || ''));
    }, [
        explicitTooltipTitle,
        getHelpNoteTooltipTitle,
        onOptionLabel,
        selectTitleText,
        selectedValue,
        title,
    ]);
    const selectedItemBody = useMemo(() => {
        const alignClass = isLayoutRTL ? 'pull-right' : 'pull-left1';
        if (onRenderSelected) {
            return onRenderSelected(selectedItem);
        }
        return (<>
        {withTitle && (isFilterBar || hasInlineLabel) ? (<span className={classnames(alignClass, styles.horizontolScroll)}>
            <span className={classnames({
            'text-semibold': !isLayoutRTL,
            'text-bold': isLayoutRTL,
        })}>
              {title}:&nbsp;
            </span>
            <span className="value">{selectTitle || t('Select One')}</span>
            {selectedItem && (<StatusAddon className={classnames('display-inline-block text-size-small', styles.statusAddon)} status={selectedItem.status}/>)}
          </span>) : null}
        {isFilterBar || hasInlineLabel ? null : (<span className={classnames('filter-option', alignClass, styles.minHeight, {
            [styles.center]: isItemCentered,
            [styles.selectedItemBodyRtl]: isLayoutRTL,
        })}>
            {selectTitle}
            {!selectedItem && labelRequired && required && <span>&nbsp;*</span>}
            {selectedItem && (<StatusAddon className={classnames('display-inline-block text-size-small', styles.statusAddon)} status={selectedItem.status}/>)}
          </span>)}
      </>);
    }, [
        isLayoutRTL,
        isItemCentered,
        hasInlineLabel,
        selectedItem,
        isFilterBar,
        onRenderSelected,
        labelRequired,
        required,
        selectTitle,
        t,
        title,
        withTitle,
    ]);
    return (<button ref={controlRef} className={classnames(buttonStyle, startSide === 'right' ? 'text-right' : 'text-left', {
        [styles.rtlButton]: isLayoutRTL && !isFilterBar,
        [styles.rtlButtonFilter]: isLayoutRTL && isFilterBar,
    })} data-cy={dataCy} data-layout-direction={direction} dir={direction} disabled={loading || disabled} title={buttonHoverTitle} type="button" onClick={handleToggleMenu}>
      <span className={classnames(styles.selectedItemBody, {
        [styles.selectedItemBodyRtl]: isLayoutRTL,
    })}>
        {selectedItemBody}
      </span>
      <span className={classnames('bs-caret', {
        [styles.rtlCaretWrapper]: isLayoutRTL,
    })}>
        <span className={classnames('caret', caretClassNames, {
        [styles.filterBarCaret]: isFilterBar,
    })}/>
      </span>
    </button>);
};
export default SelectedBoxButton;
